import React from 'react'
import {
  Sparkles,
  DollarSign,
  TrendingUp,
  PiggyBank,
  CreditCard,
  ArrowRight,
} from 'lucide-react'
import type { WorkflowPromptModalProps } from './types'
import styles from '../../pages/DocumentsPage.module.css'

export const WorkflowPromptModal: React.FC<WorkflowPromptModalProps> = ({
  isOpen,
  onClose,
  onContinueToIncome,
}) => {
  if (!isOpen) return null

  return (
    <div className={styles.workflowOverlay}>
      <div className={styles.workflowPrompt}>
        <div className={styles.workflowPromptHeader}>
          <div className={styles.workflowPromptIcon}>
            <Sparkles size={24} />
          </div>
          <h2 className={styles.workflowPromptTitle}>Documents Approved!</h2>
        </div>
        <p className={styles.workflowPromptText}>
          Your documents have been classified and are ready for analysis.
          Choose a workflow to continue:
        </p>
        <div className={styles.workflowOptions}>
          {/* Income Verification - Active */}
          <button
            className={`${styles.workflowOption} ${styles.workflowOptionActive}`}
            onClick={onContinueToIncome}
          >
            <div className={styles.workflowOptionIcon}>
              <DollarSign size={20} />
            </div>
            <div className={styles.workflowOptionInfo}>
              <div className={styles.workflowOptionTitle}>Income Verification</div>
              <div className={styles.workflowOptionDesc}>Analyze income from tax docs and pay stubs</div>
            </div>
            <span className={`${styles.workflowOptionBadge} ${styles.workflowOptionBadgeActive}`}>
              Ready
            </span>
            <ArrowRight size={18} />
          </button>

          {/* Cash Flow - Coming Soon */}
          <button className={styles.workflowOption} disabled>
            <div className={styles.workflowOptionIcon}>
              <TrendingUp size={20} />
            </div>
            <div className={styles.workflowOptionInfo}>
              <div className={styles.workflowOptionTitle}>Cash Flow Analysis</div>
              <div className={styles.workflowOptionDesc}>Review bank statements and transactions</div>
            </div>
            <span className={`${styles.workflowOptionBadge} ${styles.workflowOptionBadgeSoon}`}>
              Coming Soon
            </span>
          </button>

          {/* Assets - Coming Soon */}
          <button className={styles.workflowOption} disabled>
            <div className={styles.workflowOptionIcon}>
              <PiggyBank size={20} />
            </div>
            <div className={styles.workflowOptionInfo}>
              <div className={styles.workflowOptionTitle}>Assets</div>
              <div className={styles.workflowOptionDesc}>Verify savings and investment accounts</div>
            </div>
            <span className={`${styles.workflowOptionBadge} ${styles.workflowOptionBadgeSoon}`}>
              Coming Soon
            </span>
          </button>

          {/* Debt - Coming Soon */}
          <button className={styles.workflowOption} disabled>
            <div className={styles.workflowOptionIcon}>
              <CreditCard size={20} />
            </div>
            <div className={styles.workflowOptionInfo}>
              <div className={styles.workflowOptionTitle}>Debt Analysis</div>
              <div className={styles.workflowOptionDesc}>Calculate DTI and existing obligations</div>
            </div>
            <span className={`${styles.workflowOptionBadge} ${styles.workflowOptionBadgeSoon}`}>
              Coming Soon
            </span>
          </button>
        </div>

        <div className={styles.workflowPromptActions}>
          <button
            className={styles.workflowPromptSkip}
            onClick={onClose}
          >
            Stay on Documents
          </button>
        </div>
      </div>
    </div>
  )
}

